import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";



import swal from 'sweetalert';

import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

import Cate from './Cate';

import slid7 from '../assets/images/banner2_1920x.jpg';



import slider1 from '../assets/images/sliders (1).png'
import slider2 from '../assets/images/sliders (2).png'
import slider3 from '../assets/images/sliders (3).png'
import slider4 from '../assets/images/sliders (4).JPG'

import sl3 from '../assets/images/slide (1).png'
import sl2 from '../assets/images/slide (2).png'
import sl1 from '../assets/images/slide (3).png'

import Carousel1 from './Carosel';

import Carousel4 from './Carosel3';
import Carousel5 from './Carosel4';
import Carousel6 from './Carosel5';

import Ico from './iconBox';

// import "react-multi-carousel/lib/styles.css";

import seoData from './data';




const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};






const Home = ( props ) => {
    const  responsive= {
      0: {
          items: 1,
      },
      450: {
          items: 2,
      },
      600: {
          items: 3,
      },
      1000: {
          items: 4,
      },
  }
    const  responsive1= {
      0: {
          items: 2,
      },
      450: {
          items: 2,
      },
      600: {
          items: 3,
      },
      750: {
          items: 4,
      },
      1000: {
          items: 7,
      },
  }
    const  responsive2= {
      0: {
          items: 2,
      },
     
      450: {
          items: 3,
      },
      600: {
          items: 4,
      },
      1000: {
          items: 6,
      },
  }
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const options = {
    // margin: 30,
    // responsiveClass: true,
    // nav: true,
    // dots: false,
    // autoplay: false,
    // navText: ["Prev", "Next"],
    // smartSpeed: 1000,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 4,
        },
        1600: {
            items: 4,

        }
    },
};
//     const [options , setoptions] = useState( {
//     loop: true,
//     margin: 10,
//     nav: true,
//     responsive: {
//         0: {
//             items: 1,
//         },
//         600: {
//             items: 3,
//         },
//         1000: {
//             items: 4,
//         },
//     },
// })
    // const [Categories , setCategories] = useState([])
    // const [Categories1 , setCategories1] = useState([])
    // const [Homo , setHomo] = useState([])
    const [product , setproduct] = useState([])
    const [dis , setdis] = useState(false)

    const [product1 , setproduct1] = useState([])
    const [product8 , setproduct8] = useState([])
    const [product9 , setproduct9] = useState([])
    const [product10 , setproduct10] = useState([])
    const [product11 , setproduct11] = useState([])
    // const [UserDatat , setUserDatat] = useState({})
    // const [userHeader , setuserHeader] = useState(false)
    const [SliderPhoto , setSliderPhoto] = useState([])
    // const [ArrivalPhoto , setArrivalPhoto] = useState([])
    // const [BannerPhoto , setBannerPhoto] = useState([])
    const [MainCatogories , setMainCatogories] = useState([])
    // const [SubCategories , setSubCategories] = useState([])
    // const [SubClassCategories , setSubClassCategories] = useState([])
    const [SubClassCategories1 , setSubClassCategories1] = useState([])
    const [SubClassCategories2 , setSubClassCategories2] = useState([])
    const [DataPart2 , setDataPart2] = useState([])
    const [fvalue , setfvalue] = useState([])
    // const [data, setdata] = useState([]) 
    // const [companieswith , setcompanieswith] = useState([])
    // const [couponShow , setcouponShow] = useState(true)
    // const [chk1 , setchk1] = useState(true)
    // const [chk2 , setchk2] = useState(true)
    // const [Cate1 , setCate1] = useState([])
    // const [Cate2 , setCate2] = useState([])

    // const [Ite1 , setIte1] = useState(1)
    // const [Ite2 , setIte2] = useState(1)
    const [AllPage , setAllPage] = useState([...seoData])

    const [fg , setfg] = useState(true)
    // var settings = {
    //   infinite: true,
    //   dots: true,
    //   slidesToShow: 5,
    //   slidesToScroll: 1,
    //   lazyLoad: true,
    //   autoplay: true,
    // autoplaySpeed: 2000,
    // };
    useEffect(() =>{

        window.scrollTo(0, 0)
        setInterval(() => {
          if( document.getElementsByClassName("carousel-indicators")[0])
          document.getElementsByClassName("carousel-indicators")[0].remove()
        }, 1000);
        
      // document.getElementsByClassName("carousel-indicators")
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[0].remove()
      // document.getElementsByClassName("visually-hidden")[1].remove()
      console.log(    document.getElementsByClassName("carousel-indicators")[0]
      )
        fetch("https://malook-pk-front-back.vercel.app/slider-photo",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res=>res.json())
        .then(res1=>{
            console.log(res1[0]);
            setSliderPhoto(res1)
          })
          // carrouselInit()
      //   fetch("https://malook-pk-front-back.vercel.app/companieswith",{
      //     method: "GET",
      //      headers :  {
      //      "Content-Type" : "application/json" , 
      //  } ,
      // })
      // .then(res9=>res9.json())
      // .then(res11=>{
      //     console.log(res11[0]);
      //     setcompanieswith(res11)
      
      // })
        // fetch("https://malook-pk-front-back.vercel.app/BannerPhoto",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res22=>res22.json())
        // .then(res222=>{
        //     console.log(res222[0]);
        //     setBannerPhoto(res222)
        
        // })

        // fetch("https://malook-pk-front-back.vercel.app/arrival-photo",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res2=>res2.json())
        // .then(res3=>{
        //     console.log(res3);
        //     setArrivalPhoto(res3)
        
        // })
       

//         fetch("https://malook-pk-front-back.vercel.app/CourseAllSubCategories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res2=>res2.json())
//         .then(res3=>{
//             let data = res3.sort((a, b) => {
//                 return a.sort - b.sort;
//             });
//             // console.log(data);
//             setSubClassCategories(data)


//             fetch("https://malook-pk-front-back.vercel.app/AllCategories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res12=>res12.json())
//         .then(res13=>{
//           setSubClassCategories2(res13)
//           let a = []
//           console.log(res3,res13)
//           for (let i = 0; i < res13.length; i++) {
//           for (let j = 0; j < res3.length; j++) {
//             console.log(res3[j].MainCategories , res13[i].MainCategories , res3[j].CategoriesName , res13[i].CategoriesName )
//             if(res3[j].MainCategories === res13[i].MainCategories && res3[j].CategoriesName === res13[i].CategoriesName ){
//               // a.push("1")
// console.log(i,j)
//               a[i] = "1"
//               break
//             }
//             else{
//               a[i] = "0"
//               // a.pusH(("0"))
//             }
            
//           }
//           }
//           console.log(a)
//           setCate2(a)
//         })
//         })
        fetch("https://malook-pk-front-back.vercel.app/MainCatogories",{
            method: "GET",
             headers :  {
             "Content-Type" : "application/json" , 
         } ,
        })
        .then(res2=>res2.json())
        .then(res3=>{
            console.log(res3);
            // setMainCatogories(res3)
            

            let dat = []
            res3.map((res55,c)=>{
                dat.push(res55)
            })
            // console.log(SubClassCategories,asse)
            console.log(dat)
            let data = dat.sort((a, b) => {
                return a.sort - b.sort;
            });
            setMainCatogories(data)
            
        })
//         fetch("https://malook-pk-front-back.vercel.app/AllCategories",{
//           method: "GET",
//            headers :  {
//            "Content-Type" : "application/json" , 
//        } ,
//       })
//       .then(res2=>res2.json())
//       .then(res3=>{
//         let unique_values = res3
//         .map((item) => item.CategoriesName)
//         .filter(
//             (value, index, current_value) => current_value.indexOf(value) === index
//         );
//           // console.log(res3);
//           // const Data1 = res3.filter((res4,i)=>{
//           //     if (res4.MainCategories === props.history.location.pathname.split("/")[2])
//           //     return res4
//           // })
//           // console.log(Data1,res3)
//           setSubCategories(unique_values)
//           // setSubCategoriesname(res3)
//           fetch("https://malook-pk-front-back.vercel.app/MainCatogories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res12=>res12.json())
//         .then(res13=>{
//           let a = []
//           console.log(res13)
//           for (let i = 0; i < res13.length; i++) {
//           for (let j = 0; j < res3.length; j++) {
//             // console.log(res3[j].MainCategories , res13[i].MainCategories)
//             if(res3[j].MainCategories === res13[i].MainCategories){
//               // a.push("1")
// // console.log(i,j)
//               a[i] = "1"
//               break
//             }
//             else{
//               a[i] = "0"
//               // a.pusH(("0"))
//             }
            
//           }
//           }
//           // console.log(a)
//           setCate1(a)
//         })
//       })




        localStorage.removeItem("SearchData")
        localStorage.removeItem("Data")
        localStorage.removeItem("CartPrice")
        localStorage.removeItem("CateProduct")

        // if ( JSON.parse(localStorage.getItem("User"))  ){
        //     setuserHeader(true)
        //     setUserDatat(JSON.parse(localStorage.getItem("User")))
        //     const cartUser1 = JSON.parse(localStorage.getItem("Cart"))
        //     if (cartUser1 ){
        // fetch("https://malook-pk-front-back.vercel.app/user-cart-add",{
        //                         method: "POST",
        //                         headers :  {
        //                             "Content-Type" : "application/json" , 
        //                         } ,
        //                         body : JSON.stringify({
        //                             cart : cartUser1 ,
        //                             user : JSON.parse(localStorage.getItem("User")) 
        //                         })
        //                     })
        //                     .then(res=>res.json())
        //                     .then((res1)=>{ 
        //                         console.log(res1);
        //                     })

        //     }
        // }
        var data1 =  JSON.parse(localStorage.getItem("Cart")) 
      //   fetch("https://malook-pk-front-back.vercel.app/FAQ1",{
      //     method: "GET",
      //      headers :  {
      //      "Content-Type" : "application/json" , 
      //  } ,
      // })
      // .then(res3=>res3.json())
      // .then(res4=>{
      //   let dat1 = []
      //   res4.map((res55,c)=>{
      //       dat1.push(0)
      //   })
      //   setfvalue(dat1)
      //        setdata(res4)
      //        data.map((res,i)=>{
      //         data1[i] = res.text
      //        })

      //     console.log(res4)
      //   })
        fetch("https://malook-pk-front-back.vercel.app/AllProduct",{
       method: "GET",
        headers :  {
        "Content-Type" : "application/json" , 
    }
   })
   .then(res5=>res5.json())
   .then(res6=>{
    localStorage.setItem("Prod",JSON.stringify(res6))
    //    console.log(res6);
    const pro = []
    const pro1 = []
    const pro2 = []
    const pro3 = []
    res6.map((res7,i)=>{
        //    console.log(res7.Product_Popular );
        if ( res7.Arrival){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro.push(res7)
        }
        if ( res7.Arrival1){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro1.push(res7)
        }
        if ( res7.Arrival2){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro2.push(res7)
        }
        if ( res7.Arrival3){
            //    console.log(res7);
            //         // return setproduct1(...product1 , res3)
            pro3.push(res7)
        }
    })
    // setproduct(pro.reverse())
    setproduct8(pro)
    setproduct9(pro1)
    setproduct10(pro2)
    setproduct11(pro3)
    setproduct(pro.slice(0,8))
    setproduct1(pro1.slice(0,8))
    // setproduct1(pro1.slice(0,7))
    // setproduct1(pro1)
    setdis(true)
   })
    
//     fetch("/AllCategories",{
//        method: "GET",
//         headers :  {
//         "Content-Type" : "application/json" , 
//     } ,
//    })
//    .then(res=>res.json())
//    .then(res1=>{
//     setCategories(res1)
   
//    })

    
//     fetch("/AllHomomethtic",{
//        method: "GET",
//         headers :  {
//         "Content-Type" : "application/json" , 
//     } ,
//    })
//    .then(res3=>res3.json())
//    .then(res4=>{
//     setHomo(res4)
//     // console.log(res4);
//    })

 },[])

 const savethedetailproduct = (data) =>{
    localStorage.setItem("Data" , JSON.stringify(data) )
    console.log(data);
 }
 
 
 const cate =(Categories) =>{
     var Cat1 = Categories.split(" ").join("-")
     
     localStorage.setItem("Cate" , JSON.stringify(Categories) )
     
     setTimeout(()=>{
            props.history.push(`/shop/categories/Rs. {Cat1}`)
        },1500)
    }
    
    
//     const addtocartproduct = (data111) =>{
//     //    localStorage.setItem("Data" , JSON.stringify(data) )
//        console.log(data111);


//        if(data111.ProductCreater !== "60a3c644e4520a12c80a6f52"){
//         console.log("yes ");
//         fetch("https://malook-pk-front-back.vercel.app/ChangePercentageInOrder/"+data111.ProductCreater,{
//                             method: "POST",
//                             headers :  {
//                                 "Content-Type" : "application/json" , 
//                             }
//                         })
//                         .then(res=>res.json())
//                         .then((res1)=>{ 
//                             console.log(res1);
//                             // if(!res1 === null){
// document.getElementById("myDi").style.visibility = "visible"
//     setTimeout(()=>{
//         document.getElementById("myDi").style.visibility = "hidden"

//     },1000)
//     if (data111.Product_Price_Discounted === null){
//         const data =  {...data111 ,
                    
//                     Percentage : data111.Percentage,
//                     DeliveryStatus : "Pending",
//                      Pieces :1,
//                      Total_Product_Price  : data111.Product_Price *1}
//     var data1 = JSON.parse(localStorage.getItem("Cart")) 
//     if (data1){
//         var data3 = data1.map((item) => {
//             if(item._id === data111._id){
//                 console.log("double");
// ;                   localStorage.setItem("double",JSON.stringify(true))
//                 return {...item,
//                     Pieces :1+ item.Pieces,
//                     Total_Product_Price  : (data111.Product_Price *1)+ item.Total_Product_Price}
//             }
//             else{
//                 console.log("double not match");
//                 return item
//             }

//         })
//         var data5 =  JSON.parse(localStorage.getItem("double")) 
//         // console.log(DataPart2.length, data3.length,data5);
//         var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//         if(data10.length=== data3.length && data5){
//             console.log("double remove");
//             localStorage.removeItem("double")
//             localStorage.setItem("Cart" , JSON.stringify(data3) )
         
//         }
//         else{
//             console.log("Differet");
//             var data2 = [...data1 , data]
        
//        localStorage.setItem("Cart" , JSON.stringify(data2) )
//         }
//     }
//     else{
//         console.log("1");
//         localStorage.setItem("Cart" , JSON.stringify([data]) )
      
//     }

//     }
//     else if (data111.Product_Price_Discounted){
//         const data =  {...data111 ,
                    
//                     Percentage : data111.Percentage,
//                     DeliveryStatus : "Pending",
//                      Pieces :1,
//                      Total_Product_Price  : data111.Product_Price_Discounted *1}
//     var data1 = JSON.parse(localStorage.getItem("Cart")) 
//     if (data1){
//         var data3 = data1.map((item) => {
//             if(item._id === data111._id){
//                 console.log("double");
// ;                   localStorage.setItem("double",JSON.stringify(true))
//                 return {...item,
//                     Pieces :1+ item.Pieces,
//                     Total_Product_Price  : (data111.Product_Price_Discounted *1)+ item.Total_Product_Price}
//             }
//             else{
//                 console.log("double not match");
//                 return item
//             }

//         })
//         var data5 =  JSON.parse(localStorage.getItem("double")) 
//         // console.log(DataPart2.length, data3.length,data5);
//         var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//         if(data10.length=== data3.length && data5){
//             console.log("double remove");
//             localStorage.removeItem("double")
//             localStorage.setItem("Cart" , JSON.stringify(data3) )
         
//         }
//         else{
//             console.log("Differet");
//             var data2 = [...data1 , data]
        
//        localStorage.setItem("Cart" , JSON.stringify(data2) )
//         }
//     }
//     else{
//         console.log("1");
//         localStorage.setItem("Cart" , JSON.stringify([data]) )
      
//     }

//     }
//     else if (data111.Size_Discounted[0]){
//         const data =  {...data111 ,
//             Percentage : data111.Percentage,
//             DeliveryStatus : "Pending",
//             Pieces :1,
//             Size : data111.Size[0],
//             Product_Price_Discounted : data111.Size_Discounted[0],
//             Total_Product_Price  : data111.Size_Discounted[0] *1}
//             var data1 = JSON.parse(localStorage.getItem("Cart")) 
//             if (data1){
//             var data3 = data1.map((item) => {
//                 if(item._id === data111._id &&  item.Size === data111.Size[0]){
//                     console.log("double");
//             ;                   localStorage.setItem("double",JSON.stringify(true))
//                     return {...item,
//                         Pieces :1+ item.Pieces,
//                         Total_Product_Price  : (data111.Size_Discounted[0] *1)+ item.Total_Product_Price}
//                 }
//                 else{
//                     console.log("double not match");
//                     return item
//                 }

//             })
//             var data5 =  JSON.parse(localStorage.getItem("double")) 
//             // console.log(DataPart2.length, data3.length,data5);
//             var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//             if(data10.length=== data3.length && data5){
//                 console.log("double remove");
//                 localStorage.removeItem("double")
//                 localStorage.setItem("Cart" , JSON.stringify(data3) )
            
//             }
//             else{
//                 console.log("Differet");
//                 var data2 = [...data1 , data]
            
//             localStorage.setItem("Cart" , JSON.stringify(data2) )
//             }
//             }
//             else{
//             console.log("1");
//             localStorage.setItem("Cart" , JSON.stringify([data]) )

//             }
//     }


//     else{




//                         const data =  {...data111 ,
//                             Percentage : data111.Percentage,
//                             DeliveryStatus : "Pending",
//                             Pieces :1,
//                             Size : data111.Size[0],
//                             Product_Price_Discounted : data111.Price[0],
//                             Total_Product_Price  : data111.Price[0] *1}
//             var data1 = JSON.parse(localStorage.getItem("Cart")) 
//             if (data1){
//             var data3 = data1.map((item) => {
//                 if(item._id === data111._id &&  item.Size === data111.Size[0]){
//                     console.log("double");
//             ;                   localStorage.setItem("double",JSON.stringify(true))
//                     return {...item,
//                         Pieces :1+ item.Pieces,
//                         Total_Product_Price  : (data111.Price[0] *1)+ item.Total_Product_Price}
//                 }
//                 else{
//                     console.log("double not match");
//                     return item
//                 }

//             })
//             var data5 =  JSON.parse(localStorage.getItem("double")) 
//             // console.log(DataPart2.length, data3.length,data5);
//             var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//             if(data10.length=== data3.length && data5){
//                 console.log("double remove");
//                 localStorage.removeItem("double")
//                 localStorage.setItem("Cart" , JSON.stringify(data3) )
              
//             }
//             else{
//                 console.log("Differet");
//                 var data2 = [...data1 , data111]
             
//             localStorage.setItem("Cart" , JSON.stringify(data2) )
//             }
//             }
//             else{
//             console.log("1");
//             localStorage.setItem("Cart" , JSON.stringify([data]) )
      
//             }


//     }


//   })
    

// }













// else{
  
//                 document.getElementById("myDi").style.visibility = "visible"
//                 setTimeout(()=>{
//                 document.getElementById("myDi").style.visibility = "hidden"

//                 },1000)
//                 // console.log(productDetail);
//                 if (data111.Product_Price_Discounted === null){
//                 const data =  {...data111 ,
//                     Percentage : 0,
//                     DeliveryStatus : "Pending",
//                     Pieces :1,
//                     Total_Product_Price  : data111.Product_Price *1}
//                 var data1 = JSON.parse(localStorage.getItem("Cart")) 
//                 console.log(  data1);
//                 if (data1){
//                     console.log(  data111._id);
//                 var data3 = data1.map((item) => {
//                     console.log(item._id , data111._id);
//                     if(item._id === data111._id ){
//                         console.log("double");
//                 ;                   localStorage.setItem("double",JSON.stringify(true))
//                 return {...item,
//                     Pieces :1+ item.Pieces,
//                     Total_Product_Price  : (data111.Product_Price *1)+ item.Total_Product_Price}
//                 }
//                 else{
//                 console.log("double not match");
//                 return item
//                 }

//                 })
//                 var data5 =  JSON.parse(localStorage.getItem("double")) 
//                 // console.log(DataPart2.length, data3.length,data5);
//                 var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//                 if(data10.length=== data3.length && data5){
//                 console.log("double remove");
//                 localStorage.removeItem("double")
//                 localStorage.setItem("Cart" , JSON.stringify(data3) )

//                 }
//                 else{
//                 console.log("Differet");
//                 var data2 = [...data1 , data111]

//                 localStorage.setItem("Cart" , JSON.stringify(data2) )
//                 }
//                 }
//                 else{
//                 console.log("1");
//                 localStorage.setItem("Cart" , JSON.stringify([data]) )

//                 }

//                 }
//                 else if (data111.Product_Price_Discounted){
//                 const data =  {...data111 ,
//                     Percentage : 0,
//                     DeliveryStatus : "Pending",
//                     Pieces :1,
//                     Total_Product_Price  : data111.Product_Price_Discounted *1}
//                 var data1 = JSON.parse(localStorage.getItem("Cart")) 
//                 console.log(  data1);
//                 if (data1){
//                     console.log(  data111._id);
//                 var data3 = data1.map((item) => {
//                     console.log(item._id , data111._id);
//                     if(item._id === data111._id ){
//                         console.log("double");
//                 ;                   localStorage.setItem("double",JSON.stringify(true))
//                 return {...item,
//                     Pieces :1+ item.Pieces,
//                     Total_Product_Price  : (data111.Product_Price_Discounted *1)+ item.Total_Product_Price}
//                 }
//                 else{
//                 console.log("double not match");
//                 return item
//                 }

//                 })
//                 var data5 =  JSON.parse(localStorage.getItem("double")) 
//                 // console.log(DataPart2.length, data3.length,data5);
//                 var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//                 if(data10.length=== data3.length && data5){
//                 console.log("double remove");
//                 localStorage.removeItem("double")
//                 localStorage.setItem("Cart" , JSON.stringify(data3) )

//                 }
//                 else{
//                 console.log("Differet");
//                 var data2 = [...data1 , data111]

//                 localStorage.setItem("Cart" , JSON.stringify(data2) )
//                 }
//                 }
//                 else{
//                 console.log("1");
//                 localStorage.setItem("Cart" , JSON.stringify([data]) )

//                 }

//                 }
//                 else if (data111.Size_Discounted[0]){
//                     const data =  {...data111 ,
//                         Percentage : 0,
//                         DeliveryStatus : "Pending",
//                         Pieces :1,
//                         Size : data111.Size[0],
//                         Product_Price_Discounted : data111.Size_Discounted[0],
//                         Total_Product_Price  : data111.Size_Discounted[0] *1}
//             var data1 = JSON.parse(localStorage.getItem("Cart")) 
//             if (data1){
//             var data3 = data1.map((item) => {
//                 if(item._id === data111._id &&  item.Size === data111.Size[0]){
//                     console.log("double");
//             ;                   localStorage.setItem("double",JSON.stringify(true))
//                 return {...item,
//                     Pieces :1+ item.Pieces,
//                     Total_Product_Price  : (data111.Size_Discounted[0] *1)+ item.Total_Product_Price}
//             }
//             else{
//                 console.log("double not match");
//                 return item
//             }

//             })
//             var data5 =  JSON.parse(localStorage.getItem("double")) 
//             // console.log(DataPart2.length, data3.length,data5);
//             var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//             if(data10.length=== data3.length && data5){
//             console.log("double remove");
//             localStorage.removeItem("double")
//             localStorage.setItem("Cart" , JSON.stringify(data3) )

//             }
//             else{
//             console.log("Differet");
//             var data2 = [...data1 , data111]

//             localStorage.setItem("Cart" , JSON.stringify(data2) )
//             }
//             }
//             else{
//             console.log("1");
//             localStorage.setItem("Cart" , JSON.stringify([data]) )

//             }

//                 }
//                 else{




//                         const data =  {...data111 ,
//                             Percentage : 0,
//                             DeliveryStatus : "Pending",
//                             Pieces :1,
//                             Size : data111.Size[0],
//                             Product_Price_Discounted : data111.Price[0],
//                             Total_Product_Price  : data111.Price[0] *1}
//                 var data1 = JSON.parse(localStorage.getItem("Cart")) 
//                 if (data1){
//                 var data3 = data1.map((item) => {
//                     if(item._id === data111._id &&  item.Size === data111.Size[0]){
//                         console.log("double");
//                 ;                   localStorage.setItem("double",JSON.stringify(true))
//                     return {...item,
//                         Pieces :1+ item.Pieces,
//                         Total_Product_Price  : (data111.Price[0] *1)+ item.Total_Product_Price}
//                 }
//                 else{
//                     console.log("double not match");
//                     return item
//                 }

//                 })
//                 var data5 =  JSON.parse(localStorage.getItem("double")) 
//                 // console.log(DataPart2.length, data3.length,data5);
//                 var data10 =  JSON.parse(localStorage.getItem("Cart")) 

//                 if(data10.length=== data3.length && data5){
//                 console.log("double remove");
//                 localStorage.removeItem("double")
//                 localStorage.setItem("Cart" , JSON.stringify(data3) )

//                 }
//                 else{
//                 console.log("Differet");
//                 var data2 = [...data1 , data111]

//                 localStorage.setItem("Cart" , JSON.stringify(data2) )
//                 }
//                 }
//                 else{
//                 console.log("1");
//                 localStorage.setItem("Cart" , JSON.stringify([data]) )

//                 }


//                 }


//                     }






































//     }

    
const setChangerItemSize = (e)=>{

  if (fg) setfg(false)
  else setfg(true)

  for (let i = 0; i < 45; i++) {
    if(i === e){
      if(fvalue[e] === 0){
          fvalue[e] = 1
          // let f = document.getElementById("changeIcon"+i)
           document.getElementById("changeIcon1"+i).style.transform = "rotate(180deg)"
          
      }
      else {
          fvalue[e] = 0
          // let v = document.getElementById("changeIcon"+i)
           document.getElementById("changeIcon1"+i).style.transform = "rotate(0deg)"
          // v.innerHTML= ""
       }
    }
 
  }

setfvalue(fvalue)
  if (fg) setfg(false)
  else setfg(true)
  
}
    const carrouselInit =() => {

      var carrousel = document.getElementById("carrouselimg1");
      carrousel.style.opacity = "1";
      setInterval(carrouselAutoChange, 3500);
    
    }
    
    const carrouselAutoChange=()  =>{
      carrouselRight();
    }
    
    
    
    const carrouselChange=(i) => {
    
      var carrousel = document.getElementById("carrouselimg" + i);
      carrousel.style.opacity = "1";
    
    }
    
    
    const carrouselLeft=()  =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 0) {
                  return carrouselChange(4);
              }
              return carrouselChange(num - 1);
          }
      }
    }
    
    const carrouselRight=() =>{
    
      let nbCarrousel = 4;
      let num = 0;
    
      for (let i = 0; i < nbCarrousel; i++) {
          num = i + 1;
          var carrousel = document.getElementById("carrouselimg" + num);
          if (carrousel.style.opacity == "1") {
              carrousel.style.opacity = "0";
              if (i == 3) {
                  return carrouselChange(1);
              }
              return carrouselChange(num + 1);
          }
      }
    }
    
    
    // const addtocartproduct = (productDetail) =>{
    //   swal("Update!", "Your Item Add in Cart!", "success");
    
    //   // if(productDetail){
    //       // console.log(typeof(productDetail[0].ProductCreater), typeof("60a3c644e4520a12c80a6f52"));
          
    
    
        
    //                   if (productDetail[0].Product_Price_Discounted === null){
    //                   const data =  {...productDetail[0] ,
    //                       Percentage : 0,
    //                       DeliveryStatus : "Pending",
    //                       Pieces :1,
    //                       Total_Product_Price  : productDetail[0].Product_Price *1}
    //                   var data1 = JSON.parse(localStorage.getItem("Cart")) 
    //                   if (data1){
    //                   var data3 = data1.map((item) => {
    //                       if(item._id === data._id ){
    //                           console.log("double");
    //                   ;                   localStorage.setItem("double",JSON.stringify(true))
    //                   return {...item,
    //                       Pieces :1+ item.Pieces,
    //                       Total_Product_Price  : (productDetail[0].Product_Price *1)+ item.Total_Product_Price}
    //                   }
    //                   else{
    //                   console.log("double not match");
    //                   return item
    //                   }
    
    //                   })
    //                   var data5 =  JSON.parse(localStorage.getItem("double")) 
    //                   console.log(DataPart2.length, data3.length,data5);
    //                   var data10 =  JSON.parse(localStorage.getItem("Cart")) 
    
    //                   if(data10.length=== data3.length && data5){
    //                   console.log("double remove");
    //                   localStorage.removeItem("double")
    //                   localStorage.setItem("Cart" , JSON.stringify(data3) )
    
    //                   }
    //                   else{
    //                   console.log("Differet");
    //                   var data2 = [...data1 , data]
    
    //                   localStorage.setItem("Cart" , JSON.stringify(data2) )
    //                   }
    //                   }
    //                   else{
    //                   console.log("1");
    //                   localStorage.setItem("Cart" , JSON.stringify([data]) )
    
    //                   }
    
    //                   }
    //                   else if (productDetail[0].Product_Price_Discounted){
    //                   const data =  {...productDetail[0] ,
    //                       Percentage : 0,
    //                       DeliveryStatus : "Pending",
    //                       Pieces :1,
    //                       Total_Product_Price  : productDetail[0].Product_Price_Discounted *1}
    //                   var data1 = JSON.parse(localStorage.getItem("Cart")) 
    //                   if (data1){
    //                   var data3 = data1.map((item) => {
    //                       if(item._id === data._id ){
    //                           console.log("double");
    //                   ;                   localStorage.setItem("double",JSON.stringify(true))
    //                   return {...item,
    //                       Pieces :1+ item.Pieces,
    //                       Total_Product_Price  : (productDetail[0].Product_Price_Discounted *1)+ item.Total_Product_Price}
    //                   }
    //                   else{
    //                   console.log("double not match");
    //                   return item
    //                   }
    
    //                   })
    //                   var data5 =  JSON.parse(localStorage.getItem("double")) 
    //                   console.log(DataPart2.length, data3.length,data5);
    //                   var data10 =  JSON.parse(localStorage.getItem("Cart")) 
    
    //                   if(data10.length=== data3.length && data5){
    //                   console.log("double remove");
    //                   localStorage.removeItem("double")
    //                   localStorage.setItem("Cart" , JSON.stringify(data3) )
    
    //                   }
    //                   else{
    //                   console.log("Differet");
    //                   var data2 = [...data1 , data]
    
    //                   localStorage.setItem("Cart" , JSON.stringify(data2) )
    //                   }
    //                   }
    //                   else{
    //                   console.log("1");
    //                   localStorage.setItem("Cart" , JSON.stringify([data]) )
    
    //                   }
    
    //                   }
    
    
                          
    
    // }
    
    


const addtocartproduct = (productDetail) =>{
  swal("Update!", "Your Item Add in Cart!", "success");

      
  // document.getElementById("myDi").style.visibility = "visible"
  // setTimeout(()=>{
  // document.getElementById("myDi").style.visibility = "hidden"

  // },1000)
  console.log(productDetail)
  if (productDetail[0].Product_Price_Discounted === null){
  const data =  {...productDetail[0] ,
      Percentage : 0,
      DeliveryStatus : "Pending",
      Pieces : 1 ,
      Total_Product_Price  : productDetail[0].Product_Price * 1 }
  var data1 = JSON.parse(localStorage.getItem("Cart")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id ){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
  return {...item,
      Pieces : 1 + item.Pieces,
      Total_Product_Price  : (productDetail[0].Product_Price * 1 )+ item.Total_Product_Price}
  }
  else{
  console.log("double not match");
  return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Cart")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Cart" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Cart" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Cart" , JSON.stringify([data]) )

  }

  }
  else if (productDetail[0].Product_Price_Discounted){
  const data =  {...productDetail[0] ,
      Percentage : 0,
      DeliveryStatus : "Pending",
      Pieces : 1 ,
      Total_Product_Price  : productDetail[0].Product_Price_Discounted * 1 }
  var data1 = JSON.parse(localStorage.getItem("Cart")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id ){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
  return {...item,
      Pieces : 1 + item.Pieces,
      Total_Product_Price  : (productDetail[0].Product_Price_Discounted * 1 )+ item.Total_Product_Price}
  }
  else{
  console.log("double not match");
  return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Cart")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Cart" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Cart" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Cart" , JSON.stringify([data]) )

  }

  }
  else if (productDetail[0].Size_Discounted[0]){
      
          const data =  {...productDetail[0] ,
              Percentage : 0,
              DeliveryStatus : "Pending",
              Pieces : 1 ,
              Size : productDetail[0].Size[0],
              Product_Price_Discounted : productDetail[0].Size_Discounted[0],
              Total_Product_Price  : productDetail[0].Size_Discounted[0] * 1 }
  var data1 = JSON.parse(localStorage.getItem("Cart")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id &&  item.Size === productDetail[0].Size[0]){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
      return {...item,
          Pieces : 1 + item.Pieces,
          Total_Product_Price  : (productDetail[0].Size_Discounted[0] * 1 )+ item.Total_Product_Price}
  }
  else{
      console.log("double not match");
      return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Cart")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Cart" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Cart" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Cart" , JSON.stringify([data]) )

  }

  }
  else{




          const data =  {...productDetail[0] ,
              Percentage : 0,
              DeliveryStatus : "Pending",
              Pieces : 1 ,
              Size : productDetail[0].Size[0],
              Product_Price_Discounted : productDetail[0].Price[0],
              Total_Product_Price  : productDetail[0].Price[0] * 1 }
  var data1 = JSON.parse(localStorage.getItem("Cart")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id &&  item.Size === productDetail[0].Size[0]){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
      return {...item,
          Pieces : 1 + item.Pieces,
          Total_Product_Price  : (productDetail[0].Price[0] * 1 )+ item.Total_Product_Price}
  }
  else{
      console.log("double not match");
      return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Cart")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Cart" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Cart" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Cart" , JSON.stringify([data]) )

  }


  }


      

}

const addtocartproduct8 = (productDetail) =>{
  swal("Update!", "Item Save!", "success");

      
  // document.getElementById("myDi").style.visibility = "visible"
  // setTimeout(()=>{
  // document.getElementById("myDi").style.visibility = "hidden"

  // },1000)
  console.log(productDetail)
  if (productDetail[0].Product_Price_Discounted === null){
  const data =  {...productDetail[0] ,
      Percentage : 0,
      DeliveryStatus : "Pending",
      Pieces : 1 ,
      Total_Product_Price  : productDetail[0].Product_Price * 1 }
  var data1 = JSON.parse(localStorage.getItem("Fav")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id ){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
  return {...item,
      Pieces : 1 + item.Pieces,
      Total_Product_Price  : (productDetail[0].Product_Price * 1 )+ item.Total_Product_Price}
  }
  else{
  console.log("double not match");
  return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Fav")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Fav" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Fav" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Fav" , JSON.stringify([data]) )

  }

  }
  else if (productDetail[0].Product_Price_Discounted){
  const data =  {...productDetail[0] ,
      Percentage : 0,
      DeliveryStatus : "Pending",
      Pieces : 1 ,
      Total_Product_Price  : productDetail[0].Product_Price_Discounted * 1 }
  var data1 = JSON.parse(localStorage.getItem("Fav")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id ){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
  return {...item,
      Pieces : 1 + item.Pieces,
      Total_Product_Price  : (productDetail[0].Product_Price_Discounted * 1 )+ item.Total_Product_Price}
  }
  else{
  console.log("double not match");
  return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Fav")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Fav" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Fav" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Fav" , JSON.stringify([data]) )

  }

  }
  else if (productDetail[0].Size_Discounted[0]){
      
          const data =  {...productDetail[0] ,
              Percentage : 0,
              DeliveryStatus : "Pending",
              Pieces : 1 ,
              Size : productDetail[0].Size[0],
              Product_Price_Discounted : productDetail[0].Size_Discounted[0],
              Total_Product_Price  : productDetail[0].Size_Discounted[0] * 1 }
  var data1 = JSON.parse(localStorage.getItem("Fav")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id &&  item.Size === productDetail[0].Size[0]){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
      return {...item,
          Pieces : 1 + item.Pieces,
          Total_Product_Price  : (productDetail[0].Size_Discounted[0] * 1 )+ item.Total_Product_Price}
  }
  else{
      console.log("double not match");
      return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Fav")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Fav" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Fav" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Fav" , JSON.stringify([data]) )

  }

  }
  else{




          const data =  {...productDetail[0] ,
              Percentage : 0,
              DeliveryStatus : "Pending",
              Pieces : 1 ,
              Size : productDetail[0].Size[0],
              Product_Price_Discounted : productDetail[0].Price[0],
              Total_Product_Price  : productDetail[0].Price[0] * 1 }
  var data1 = JSON.parse(localStorage.getItem("Fav")) 
  if (data1){
  var data3 = data1.map((item) => {
      if(item._id === data._id &&  item.Size === productDetail[0].Size[0]){
          console.log("double");
  ;                   localStorage.setItem("double",JSON.stringify(true))
      return {...item,
          Pieces : 1 + item.Pieces,
          Total_Product_Price  : (productDetail[0].Price[0] * 1 )+ item.Total_Product_Price}
  }
  else{
      console.log("double not match");
      return item
  }

  })
  var data5 =  JSON.parse(localStorage.getItem("double")) 
  console.log(DataPart2.length, data3.length,data5);
  var data10 =  JSON.parse(localStorage.getItem("Fav")) 

  if(data10.length=== data3.length && data5){
  console.log("double remove");
  localStorage.removeItem("double")
  localStorage.setItem("Fav" , JSON.stringify(data3) )

  }
  else{
  console.log("Differet");
  var data2 = [...data1 , data]

  localStorage.setItem("Fav" , JSON.stringify(data2) )
  }
  }
  else{
  console.log("1");
  localStorage.setItem("Fav" , JSON.stringify([data]) )

  }


  }


      

}

const setIsShown1 = (data) =>{
  console.log(SubClassCategories2,data)
  const NonActive = SubClassCategories2.filter((res9,i)=>{
    // console.log(res9.status , res9.Product_Catagories , Categoriesname.categoriesName  , res9.Product_Sub_Catagories , Categoriesname.subCate );
    if( res9.MainCategories === data.MainCategories   ){
        return res9 
    }
})
console.log(NonActive)
setSubClassCategories1(NonActive)
// console.log(NonActive)

  document.getElementById("drf").style.display = "block"
  console.log("1")
}

const setIsShown3 = () =>{
  document.getElementById("drf").style.display = "block"
  console.log("1")
}

const setIsShown2 = () =>{
  document.getElementById("drf").style.display = "none"

}
    
        return (
            
          <div>
          <div className="page-wrapper">
            
            {/* End .header */}
            <main className="main">
            {/* <main className="main" style={{backgroundColor: '#fafafa'}}> */}
              <div className="intro-section change-height-slider" >
                <div className="container">
                  <div className="row">
                    
                    <div className="col-xl-12 col-md-12 col-12 mb-md-0" style={{padding:"0px"}}>
                      <div className="intro-slider-container">
                        {/* <div className="intro-slider owl-carousel owl-theme owl-nav-inside row cols-1" data-toggle="owl" data-owl-options="{
                                          &quot;nav&quot;: false,
                                          &quot;dots&quot;: true,
                                          &quot;autoplay&quot;: false,
                                          &quot;autoplayTimeout&quot;: 10000,
                                          &quot;animateOut&quot;: &quot;fadeOut&quot;
                                      }"> */}










{/* <Slider {...settings}>   */}

<Carousel autoPlay={true} interval={4000} showThumbs={false} showArrows={true} showStatus={false} swipeable={true} swipeAble={true} infiniteLoop={true} style={{height: "300px"}}>


<div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}}  onClick={()=>props.history.push("/categories/Bridals/all-products")}>
    <img src={slider1} alt="" className='change-slid' style={{height: "920px"}}/>
  </div>
<div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}}  onClick={()=>props.history.push("/categories/Bridals/all-products")}>
    <img src={sl1} alt="" className='change-slid' style={{height: "920px"}}/>
  </div>
<div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}}  onClick={()=>props.history.push("/categories/Bridals/all-products")}>
    <img src={sl2} alt="" className='change-slid' style={{height: "920px"}}/>
  </div>
  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} onClick={()=>props.history.push("/categories/Formals/all-products")}   >
    <img src={slider2} alt="" className='change-slid' style={{height: "920px"}}   />
  </div>
  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} onClick={()=>props.history.push("/categories/Lawn/all-products")}>
    <img src={slider3} alt="" className='change-slid' style={{height: "920px"}}/>
  </div>

  <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}}  onClick={()=>props.history.push("/categories/Bridals/all-products")}>
    <img src={sl3} alt="" className='change-slid' style={{height: "920px"}}/>
  </div>

  {/* <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}}  onClick={()=>props.history.push("/categories/Garden%20Accessories/all-products")}>
    <img src={slid5} alt="" className='change-slid' style={{height: "585px"}}/>
  </div> */}


  {/* {SliderPhoto[0] &&SliderPhoto[0].photo1 !== null ? 
    <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} >
    <img src={SliderPhoto[0].photo1} alt="" className='change-slid' style={{height: "485px"}}/>
  </div>
    :""
  }
  {SliderPhoto[0] &&SliderPhoto[0].photo2 !== null ? 
    <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} >
    <img src={SliderPhoto[0].photo2} alt="" className='change-slid' style={{height: "485px"}}/>
  </div>
        :""
      }
  {SliderPhoto[0] &&SliderPhoto[0].photo3 !== null? 
    <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} >
    <img src={SliderPhoto[0].photo3} alt="" className='change-slid' style={{height: "485px"}}/>
  </div>
    :""
  }
  {SliderPhoto[0] &&SliderPhoto[0].photo4!== null ? 
    <div className="intro-slide bg-image d-flex align-items-center change-slid1"  style={{ height: "320px"}} >
    <img src={SliderPhoto[0].photo4} alt="" className='change-slid' style={{height: "485px"}}/>
  </div>
  :""
} */}
  </Carousel>


                          {/* </Slider> */}

                          {/* End .intro-slide */}
                        </div>
                        {/* End .intro-slider owl-carousel owl-simple */}
                        {/* 
                                      <span class="slider-loader"></span>
                                  End .slider-loader */}
                      {/* </div> */}
                    </div>
                    {/* <div className="col-lg-5cols col-md-3 col-12 mb-md-0 mb-2">
                      <div className="banner banner-overlay bg-image h-100 mb-0" style={{backgroundColor: '#f1f1f1', backgroundImage: 'url(assets/images/demos/demo-26/banners/banner-1.jpg)'}}>
                        <div className="banner-content position-relative pt-0 pb-md-7 d-flex flex-column">
                          <div className="title text-center text-uppercase text-dark font-weight-bold mb-0">
                            Phantom 3
                            <br />Professional
                          </div>
                          <div className="price text-center">
                            <sup className="text-dark font-weight-normal">from
                              <span className="text-primary font-weight-normal">Rs. </span>
                            </sup>
                            <span className="text-primary font-weight-bold">
                              599.
                            </span>
                            <sup className="text-primary font-weight-bold" style={{fontSize: '55%', top: '-.6em'}}>99</sup>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>




             

              {/* <div className="container electronics fashion">
                <div className="bg-lighter trending-products">
                  <div className="heading heading-flex">
                    <div className="heading-left">
                      <h2 className="title font-weight-bold mb-1">Home  &amp; Appliances</h2>
                    </div>
                    <div className="heading-right">
                      <ul className="nav nav-pills justify-content-center mr-n3" role="tablist">
                        {SubCategories.map((res,i)=>{
                          let ab = res.replace(" " , "-")

                          if(i === 0){
                            return(
                              <li className="nav-item">
                              <span className="nav-link font-size-normal font-weight-normal text-uppercase dfkljsdklj active" id={`fashion-${ab}-link`} data-toggle="tab" href={`#fashion-${ab}-tab`} role="tab" aria-controls={`fashion-${ab}-tab`} aria-selected="true" style={{color : "black"}} >{res}</span>
                            </li>
                            )
                          }
                          else{
                            return(
                              <li className="nav-item">
                              <span className="nav-link font-size-normal font-weight-normal text-uppercase dfkljsdklj" id={`fashion-${ab}-link`} data-toggle="tab" href={`#fashion-${ab}-tab`} role="tab" aria-controls={`fashion-${ab}-tab`} aria-selected="true" style={{color : "black"}} >{res}</span>
                            </li>
                            )
                          }
                        })

                        }
                        
                      </ul>
                    </div>
                  </div>
                  <div className="tab-content tab-content-carousel position-relative">
                  {SubCategories.map((res,i)=>{
                    let ab = res.replace(" " , "-")
                          if(i === 0){
                            return(
                              <div className="tab-pane p-0 fade show active" id={`fashion-${ab}-tab`} role="tabpanel" aria-labelledby={`fashion-${ab}-link`}>
                                <div>
                                    <Carousel3 handleClick={res} />
                                </div>
                              </div>
                            )
                          }
                          else{
                            return(
                              <div className="tab-pane p-0 fade" id={`fashion-${ab}-tab`} role="tabpanel" aria-labelledby={`fashion-${ab}-link`}>
                                <div>
                                    <Carousel3 handleClick={res} />
                                </div>
                            </div>
                            )
                          }
                        })

                        }
                    
                    </div>
                    
                </div>
              </div>




           */}













          































<div className="container deal-section" style={{backgroundColor:"#f7f1f0"}}>
                <br />
                <center>

<h3 className="title text-center font-weight-bold mt-1 mb-2" style={{marginBottom : "0px",borderBottom :"3px solid rgb(40, 108, 83)",width: "fit-content",textAlign:"center"}}>Best Sellers</h3>
</center>
                
                <div>
            

<Carousel1/>
      
                </div>  
              </div>



















             <br />

              <div className="container banner-group-1">
                <div className="categories">
                  {/* <center>

                  <h3 className="title text-center font-weight-bold mt-1" style={{marginBottom : "0px",borderBottom :"3px solid rgb(40, 108, 83)",width: "fit-content",textAlign:"center"}}>Top Categories this Week</h3>
                  </center> */}
                  <div 
                
                              >
     
                  
                    
                    <div className='row' style={{}}>
                    <Cate />
                
                                                {/* <div className="col-lg-6 col-sm-12 category position-relative" style={{margin:"10px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                            <div>
                                                  <Link style={{  display: "flex",
    justifyContent: "center",
    alignItems: "flex-end" }} to={"/categories-main/"+"Annual Maintenance Contract"} >
                                                <img src={slid1} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} />
                                               <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                            fontWeight: "400"}}>Annual Maintenance Contract        </b> </span>
                                              </Link>
                                            </div>
                                            
                                          </div>
                                                <div className="col-lg-3 col-sm-12 category position-relative" style={{margin:"10px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                            <div>
                                                  <Link style={{  display: "flex",
    justifyContent: "center",
    alignItems: "flex-end" }} to={"/categories-main/"+"Annual Maintenance Contract"} >
                                                <img src={slid1} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} />
                                               <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                            fontWeight: "400"}}>Bridal        </b> </span>
                                              </Link>
                                            </div>
                                            
                                          </div>
                                                <div className="col-lg-3 col-sm-12 category position-relative" style={{margin:"10px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                            <div>
                                                  <Link style={{  display: "flex",
    justifyContent: "center",
    alignItems: "flex-end" }} to={"/categories-main/"+"Annual Maintenance Contract"} >
                                                <img src={slid1} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",objectFit:"cover" ,margin: "auto"}} />
                                               <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                            fontWeight: "400"}}>Formal        </b> </span>
                                              </Link>
                                            </div>
                                            
                                          </div> */}
                                           
                                             







                                          </div>





                  </div>
                </div>
              
           

              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="">
                      <div className="bg-image d-flex justify-content-center kjkjkjkj" style={{backgroundImage: 'url('+slid7+')',backgroundRepeat : "no-repeat" ,height:  "410px",backgroundColor : "transparent"}}>
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              
                <div className="container icon-boxes-section">
                <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2">

                  <div>
                 
                 < Ico/>
                

                  </div>

                </div>



           <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>

              <h1 className="title font-weight-bold" style={{  height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545"}}> BRIDAL COUTURE
  
</h1>
                        
                </div>
                <div>
             



<Carousel4/><br />          


           <center>
           <Link to={"/categories/Bridals/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 18px",fontSize:"16px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>

            </center>  
            <br />          
                </div>  
              </div>
              <br />
              <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>
                <h1 className="title font-weight-bold" style={{height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545"}}> LUXURY PRET



</h1>
{/* <Link to={"/categories/Luxury Pret/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 8px" ,  background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link> */}
                        
                        </div>
                        <div>
                     


<Carousel5/><br />          

<center>
<Link to={"/categories/Luxury Pret/all-products" }><span  className="heading-right" style={{color : "white" ,padding : "7px 18px",fontSize:"16px" , background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>
</center>

<br />          
                
                </div>  
              </div>
              <br />
              <div className="container deal-section">
                <div style={{display : "flex",marginBottom: "10px",
    justifyContent: "center"}}>
                <h1 className="title font-weight-bold" style={{height: "39px",padding  : "0px",margin : "0px" , borderBottom : "2px solid #454545"}}> Lawn 

</h1>
                        
                        </div>
                        <div>
                     



<Carousel6/>
<br />          

<center>
<Link to={"/categories/Lawn/all-products" }><span  className="heading-right" style={{color : "white" , padding : "7px 18px",fontSize:"16px" , background  :"#454545", fontWeight  : "600"}} >VIEW ALL</span></Link>

</center>
<br />          
                 
                </div>  
              </div>
   
          







                <hr className="mt-2 mb-0" />
              </div>

                
              </div>
              <br />
              
              {/* End .container-fluid */}
             
              
              
              {/* <div className="container banner-group-2">
                <div className="row row-sm">
                  <div className="col-md-6">
                    <div className="banner-overlay" style={{backgroundImage: 'url('+ch344+')',backgroundSize : "cover",backgroundColor : "none" ,backgroundRepeat :"no-repeat",marginBottom : "20px"}} >
                      <div className="banner-content banner-content-left position-relative">
                        <h4 className="banner-subtitle letter-spacing-normal font-size-normal font-weight-light mb-1"  style={{color : "black"}}>
                          <Link to="/product/recommended-product">Flash Sale is Coming</Link>
                        </h4>
                        <h3 className="banner-title font-weight-bold mb-0" style={{color : "black"}}>
                          <Link to="/product/recommended-product" className="fefee">Home Appliances
                            </Link>
                        </h3>
                        <h4 className="banner-text text-secondary font-weight-normal">upto 15% off</h4>
                        <Link to="/product/recommended-product" className="btn-product font-size-normal text-uppercase text-decoration-none btn-rounded" style={{background : "rgb(235, 61, 50)",border: "none",color : "white"}}>Shop Now&nbsp;&nbsp;
                          <i className="icon-long-arrow-right d-inline-block" />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="banner-overlay" style={{backgroundImage: 'url('+ch3444+')',backgroundSize : "cover",backgroundColor : "none" ,backgroundRepeat :"no-repeat",marginBottom : "20px"}}>
                      <div className="banner-content banner-content-left position-relative">
                        <h4 className="banner-subtitle letter-spacing-normal font-size-normal font-weight-light mb-1"   style={{color : "black"}}>
                          <Link to="/main-categories/Kitchen%20Appliances">Mega Sale is Coming</Link>
                        </h4>
                        <h3 className="banner-title font-weight-bold mb-0" style={{color : "black"}}>
                          <Link to="/main-categories/Kitchen%20Appliances" className="fefee">kitchen Appliances
                            </Link>
                        </h3>
                        <h4 className="banner-text text-secondary font-weight-normal">upto 18% off</h4>
                        <Link to="/main-categories/Kitchen%20Appliances" className="btn-product font-size-normal text-uppercase text-decoration-none btn-rounded" style={{background : "rgb(235, 61, 50)",border: "none",color : "white"}}>Shop Now&nbsp;&nbsp;
                          <i className="icon-long-arrow-right d-inline-block" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}


             

              {/* <div className="container deal-section">
            
<center>

<h3 className="title text-center font-weight-bold mt-1 mb-2" style={{marginBottom : "0px",borderBottom :"3px solid rgb(40, 108, 83)",width: "fit-content",textAlign:"center"}}>Recommended Products</h3>
</center>
                <div
              
                      >
                      


                    <Carousel2 />



                </div>  
              </div> */}


              
              {/* <div className="bg-white brand-section pt-5 pb-4">
                <div className="container">
                  <div className="owl-carousel owl-simple brands-carousel row cols-2 cols-xs-3 cols-sm-4 cols-lg-5 cols-xxl-6" data-toggle="owl" data-owl-options="{
                              &quot;nav&quot;: false, 
                              &quot;dots&quot;: false,
                              &quot;margin&quot;:  0,
                              &quot;loop&quot;: false,
                              &quot;responsive&quot;: {
                                  &quot;0&quot;: {
                                      &quot;items&quot;:2
                                  },
                                  &quot;480&quot;: {
                                      &quot;items&quot;:3
                                  },
                                  &quot;576&quot;: {
                                      &quot;items&quot;:4
                                  },
                                  &quot;992&quot;: {
                                      &quot;items&quot;:5
                                  },
                                  &quot;1600&quot;: {
                                      &quot;items&quot;:6
                                  }
                              }
                          }">
                    <span  className="brand">
                      <img src="assets/images/brands/1.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/2.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/3.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/4.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/5.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/6.png" alt="Brand Name" width={85} height={35} />
                    </span>
                    <span  className="brand">
                      <img src="assets/images/brands/7.png" alt="Brand Name" width={85} height={35} />
                    </span>
                  </div>
                  <hr className="mt-5 mb-0" />
                </div>
              </div> */}




<div className='container' style={{margin : "30px 10px",width:"96%"}}>
            <div className='row'  style={{margin  :"auto"}} >
            <div className="col-lg-10 col-sm-12" style={{margin  :"auto"}}>



            <h1 style={{fontSize:"24px",fontWeight:"600",margin:"0px"}}>Premier Destination for Fashion Designer & Bridal Dress in Lahore Pakistan</h1>

<p style={{    color: "black"}}>At <strong>Malookcouture.com</strong>, we are dedicated to bringing the latest trends and timeless elegance to your wardrobe. With a diverse selection of <strong>designer clothing</strong> and <strong>accessories</strong>, we aim to help you express your unique style and personality. With over <strong>10 years of experience</strong> in the fashion industry, our passionate team is committed to providing you with high-quality products and exceptional service. Whether you’re looking for <strong>luxury formal wear</strong> or trendy casual outfits, we’re here to enhance your fashion experience. Explore our range and let your style shine with <strong>Malookcouture.com</strong>.</p>
<br />
<h3 style={{fontSize:"24px",fontWeight:"600",margin:"0px"}}>Our Mission:</h3>
<p style={{    color: "black"}}>At <strong>Malookcouture.com</strong>, our mission is to empower individuals to embrace their personal style through high-quality fashion. We strive to inspire our customers to express themselves confidently with our diverse selection of clothing and accessories.</p>

<br />
<h3 style={{fontSize:"24px",fontWeight:"600",margin:"0px"}}>Expertise and Experience:</h3>
<p style={{    color: "black"}}>With over <strong>10 years of experience</strong> in the fashion industry, <strong>Malookcouture.com</strong> boasts a team of dedicated fashion experts who are passionate about style and quality. Our team’s extensive knowledge ensures that you receive personalized guidance and support to find the perfect pieces for your wardrobe.</p>

<br />
<h3 style={{fontSize:"24px",fontWeight:"600",margin:"0px"}}>Product Categories:</h3>
<ul style={{    color: "black"}}>
    <li style={{    color: "black"}}><strong>Luxury Formal Wear:</strong> Elevate your special occasions with our exquisite collection of formal wear, designed to make you stand out with elegance and sophistication.</li>
    <li style={{    color: "black"}}><strong>Casual Wear:</strong> Discover our trendy casual wear that combines comfort and style, perfect for everyday outings or relaxed gatherings.</li>
    <li style={{    color: "black"}}><strong>Pret Wear:</strong> Our ready-to-wear collection offers a variety of stylish outfits that are perfect for any occasion, ensuring you look effortlessly chic.</li>
    <li style={{    color: "black"}}><strong>Accessories:</strong> Complete your look with our curated selection of accessories, including bags, jewelry, and more, designed to add the perfect finishing touch to your outfit.</li>
</ul>

<br />
<h3>Transform Your Wardrobe:</h3>
<p style={{    color: "black"}}>Whether you’re a fashion enthusiast or just starting to explore your style, <strong>Malookcouture.com</strong> is here to help you transform your wardrobe into a reflection of your personality. Explore our range today and let your fashion journey begin with <strong>Malookcouture.com</strong>.</p>
          
          
          
          
            
          
           <br />
  <h5>Our Services</h5>
  <p>

  {
    AllPage.map((res,i)=>{
      return(
          <Link to={"/pages/"+res.url}>{res.title} </Link>
      )
    })
  }
                                  
    <Link style={{padding: "10px"}} to="/hire-the-best-fashion-designers-in-the-united-states">Hire the best Fashion Designers in the United States</Link>
<Link style={{padding: "10px"}} to="/luxury-fashion-designer-clothing-in-usa">Luxury Fashion & Designer Clothing in USA</Link>
<Link style={{padding: "10px"}} to="/world-famous-luxury-brands-and-designers-in-usa">World famous luxury brands and designers in USA</Link>
<Link style={{padding: "10px"}} to="/custom-clothing-design-and-sell-online-in-usa">Custom Clothing - Design and Sell Online in USA</Link>
<Link style={{padding: "10px"}} to="/designer-clothing-luxury-fashion-women-dresses">Designer Clothing | Luxury Fashion | Women Dresses</Link>
<Link style={{padding: "10px"}} to="/women-clothes-designer-for-clothing-in-usa">Women clothes designer for clothing in USA</Link>
<Link style={{padding: "10px"}} to="/best-clothes-designer-for-clothing-in-usa">Best clothes designer for clothing in USA</Link>
<Link style={{padding: "10px"}} to="/clothes-designer-for-clothing-in-usa-online">Clothes designer for clothing in USA online</Link>
<Link style={{padding: "10px"}} to="/cheap-clothes-designer-for-clothing-in-usa">Cheap clothes designer for clothing in USA</Link>
<Link style={{padding: "10px"}} to="/women-dresses-usa-shop-original-clothes-online">Women Dresses USA · Shop Original Clothes Online</Link>
<Link style={{padding: "10px"}} to="/wedding-dresses-bridesmaids-prom-gowns-in-usa">Wedding Dresses, Bridesmaids & Prom Gowns in USA</Link>
<Link style={{padding: "10px"}} to="/sale-usa-bridal-wedding-dresses-bridal-shops-near-me">SALE USA BRIDAL Wedding Dresses | Bridal Shops Near Me</Link>
<Link style={{padding: "10px"}} to="/wedding-gowns-dresses-evening-dresses-in-usa">Wedding Gowns & Dresses , Evening dresses in USA</Link>
<Link style={{padding: "10px"}} to="/bridal-collection-usa-shop-wedding-dresses-online">Bridal Collection USA | Shop Wedding Dresses Online</Link>
<Link style={{padding: "10px"}} to="/women-bridal-dress-in-usa-online">Women bridal dress in USA online</Link>
<Link style={{padding: "10px"}} to="/maxi-women-bridal-dress-in-usa">Maxi women bridal dress in USA</Link>
<Link style={{padding: "10px"}} to="/luxury-wedding-dresses-designer-formal-wear-usa">Luxury Wedding Dresses & Designer Formal Wear USA</Link>
<Link style={{padding: "10px"}} to="/usa-bridal-wedding-dresses-bridal-shops-near">USA Bridal - Wedding Dresses | Bridal Shops Near</Link>
<Link style={{padding: "10px"}} to="/wedding-dresses-bridal-dresses-malook-couture">Wedding Dresses | Bridal Dresses | Malook Couture</Link>
<Link style={{padding: "10px"}} to="/pakistani-wedding-dresses-for-women-in-usa">Pakistani Wedding Dresses for Women in USA</Link>
<Link style={{padding: "10px"}} to="/buy-latest-pakistani-wedding-dresses-in-usa">Buy Latest Pakistani Wedding Dresses in USA</Link>
<Link style={{padding: "10px"}} to="/luxurious-pakistani-bridal-dresses-in-usa">Luxurious Pakistani Bridal Dresses in USA</Link>
<Link style={{padding: "10px"}} to="/pakistani-wedding-dresses-bridal-gowns">Pakistani Wedding Dresses & Bridal Gowns</Link>
<Link style={{padding: "10px"}} to="/pakistani-bridal-dresses-for-barat-in-usa">Pakistani Bridal Dresses for Barat in USA</Link>
<Link style={{padding: "10px"}} to="/buy-pakistani-bridal-dresses-wedding-wear-online">Buy Pakistani Bridal Dresses & Wedding Wear Online</Link>
<Link style={{padding: "10px"}} to="/pakistani-bridal-dresses-latest-designs-online">Pakistani Bridal Dresses Latest Designs Online</Link>
<Link style={{padding: "10px"}} to="/wedding-dresses-wedding-reception-dresses-for-bride">Wedding Dresses | Wedding Reception Dresses for Bride</Link>
<Link style={{padding: "10px"}} to="/bridal-online-shop-dresses-outfits-for-every-event">Bridal Online Shop - Dresses & Outfits for Every Event</Link>
<Link style={{padding: "10px"}} to="/best-places-to-buy-wedding-dresses-online-of-2025">Best Places to Buy Wedding Dresses Online of 2025</Link>
<Link style={{padding: "10px"}} to="/luxury-wedding-dresses-gowns-online-bridal-shop">Luxury Wedding Dresses & Gowns | Online Bridal Shop</Link>


<Link style={{padding: "10px"}} to="/wedding-dresses-2025-bridal-gowns">Wedding Dresses 2025 | Bridal Gowns</Link>
<Link style={{padding: "10px"}} to="/wedding-dresses-wedding-gowns-and-bridal-wear">Wedding Dresses , Wedding Gowns and Bridal Wear</Link>
<Link style={{padding: "10px"}} to="/the-wedding-shop-bridal-gowns-wedding-party-attire">The Wedding Shop | Bridal Gowns & Wedding Party Attire</Link>
<Link style={{padding: "10px"}} to="/buy-indian-wedding-dresses-online-in-usa">Buy Indian Wedding Dresses Online in USA</Link>
<Link style={{padding: "10px"}} to="/womens-designer-wedding-dresses-sale-up-to-70-off">Women's Designer Wedding Dresses | Sale Up To 70% Off</Link>
<Link style={{padding: "10px"}} to="/womens-formal-dresses-evening-gowns">Women's Formal Dresses & Evening Gowns</Link>
<Link style={{padding: "10px"}} to="/formal-dresses-evening-gowns-for-women">Formal Dresses & Evening Gowns for Women</Link>
<Link style={{padding: "10px"}} to="/formal-dresses-women-malook-united-states">Formal Dresses Women | Malook United States</Link>
<Link style={{padding: "10px"}} to="/formal-dresses-for-women-shop-online-usa">Formal Dresses for Women - Shop Online USA</Link>
<Link style={{padding: "10px"}} to="/womens-formal-wear-pakistani-dresses-in-usa">Women's Formal Wear | Pakistani Dresses in USA</Link>
<Link style={{padding: "10px"}} to="/women-formal-dress-in-usa-online">Women formal dress in USA online</Link>
<Link style={{padding: "10px"}} to="/best-women-formal-dress-in-usa">Best women formal dress in USA</Link>
<Link style={{padding: "10px"}} to="/formal-dress-for-women-office-wear">Formal dress for women-office wear</Link>
<Link style={{padding: "10px"}} to="/shop-womens-formal-dresses-outfits-online-us">Shop Women's Formal Dresses & Outfits Online US</Link>
<Link style={{padding: "10px"}} to="/womens-formal-dresses-evening-gowns">Women's Formal Dresses & Evening Gowns</Link>
<Link style={{padding: "10px"}} to="/womens-dresses-party-occasion-evening-dresses">Women's Dresses | Party, Occasion & Evening Dresses</Link>
<Link style={{padding: "10px"}} to="/buy-formal-dresses-for-women-at-best-prices">Buy Formal Dresses For Women at Best Prices</Link>
<Link style={{padding: "10px"}} to="/formal-dress-sold-on-malook-united-states">Formal dress sold on Malook United States</Link>
<Link style={{padding: "10px"}} to="/formal-dresses-sexy-womens-formal-gowns">Formal Dresses | Sexy Women's Formal Gowns</Link>
<Link style={{padding: "10px"}} to="/designer-formal-dresses-and-evening-gowns-for-women">Designer Formal Dresses And Evening Gowns for Women</Link>





<Link style={{padding: "10px"}} to="/formal-dresses-evening-gowns-long-elegant">Formal Dresses & Evening Gowns: Long & Elegant</Link>
<Link style={{padding: "10px"}} to="/womens-designer-formal-dresses-evening-gowns">Women's Designer Formal Dresses & Evening Gowns</Link>
<Link style={{padding: "10px"}} to="/evening-dresses-womens-party-cocktail-formal-dresses">Evening Dresses | Women's Party, Cocktail & Formal Dresses</Link>
<Link style={{padding: "10px"}} to="/women-3-piece-pret-stitched-suit-online-in-usa">Women 3 Piece Pret Stitched Suit Online in USA</Link>
<Link style={{padding: "10px"}} to="/shop-asian-3-piece-stitched-suits-wedding-outfits-usa">Shop Asian 3 Piece Stitched Suits, Wedding Outfits USA</Link>
<Link style={{padding: "10px"}} to="/malook-couture-womens-luxury-dresses">Malook Couture Women's Luxury Dresses</Link>
<Link style={{padding: "10px"}} to="/luxury-pret-online-women-dresses-malook">Luxury Pret - Online Women Dresses - Malook</Link>
<Link style={{padding: "10px"}} to="/women-lawn-pret-collection">Women Lawn Pret Collection</Link>
<Link style={{padding: "10px"}} to="/womens-pakistani-luxury-pret-online-in-uk-usa">Women's Pakistani Luxury Pret Online in UK & USA</Link>
<Link style={{padding: "10px"}} to="/shop-luxury-pret-wear-collection">Shop Luxury Pret Wear Collection</Link>
<Link style={{padding: "10px"}} to="/womens-clothing-online-in-usa-buy-latest-design">Women's Clothing Online in USA | Buy Latest Design</Link>
<Link style={{padding: "10px"}} to="/womens-luxury-pret-formal-wear">Women's Luxury Pret & Formal Wear</Link>
<Link style={{padding: "10px"}} to="/luxury-pret-buy-pakistani-dresses-in-usa-uk">Luxury Pret Buy Pakistani Dresses in USA & UK</Link>
<Link style={{padding: "10px"}} to="/women-pret-dress-in-usa-online">Women Pret Dress in USA Online</Link>
<Link style={{padding: "10px"}} to="/pakistani-women-pret-dress-in-usa">Pakistani Women Pret Dress in USA</Link>
<Link style={{padding: "10px"}} to="/casual-women-pret-dress-in-usa">Casual Women Pret Dress in USA</Link>
<Link style={{padding: "10px"}} to="/pakistani-luxury-pret-collection-women-dresses">Pakistani Luxury Pret Collection - Women Dresses</Link>
<Link style={{padding: "10px"}} to="/luxury-pret-women-pret-wear-collection">Luxury Pret | Women Pret Wear Collection</Link>
<Link style={{padding: "10px"}} to="/new-ready-to-wear-dresses-pret-collection-2025">New Ready to Wear Dresses | Pret Collection 2025</Link>
<Link style={{padding: "10px"}} to="/unstitched-pret-womens-clothing-malook-store">Unstitched & Pret Women's Clothing – Malook Store</Link>
<Link style={{padding: "10px"}} to="/stylish-pret-collection-ready-to-wear-womens">Stylish Pret Collection - Ready-to-Wear Women's</Link>
<Link style={{padding: "10px"}} to="/pakistani-womens-pret-wear-online">Pakistani Women's Pret Wear Online</Link>
<Link style={{padding: "10px"}} to="/pakistani-women-pret-new-arrivals">Pakistani Women PRET New Arrivals</Link>
<Link style={{padding: "10px"}} to="/ready-to-wear-pakistani-dresses-for-women">Ready To Wear | Pakistani Dresses For Women</Link>
<Link style={{padding: "10px"}} to="/luxury-pret-online-luxury-ready-to-wear">Luxury Pret Online and Luxury Ready to Wear</Link>
<Link style={{padding: "10px"}} to="/pret-unstitched-dresses-on-sale">Pret & Unstitched Dresses On Sale</Link>
<Link style={{padding: "10px"}} to="/get-the-latest-womens-clothes-dresses">Get the latest women's clothes dresses</Link>
<Link style={{padding: "10px"}} to="/ready-to-wear-womens-stitched-pret-waer">Ready to Wear | Women's Stitched | Pret Wear</Link>
<Link style={{padding: "10px"}} to="/buy-summer-ready-to-wear-pret-eid-dresses-usa">Buy Summer Ready To Wear Pret Eid Dresses USA</Link>
<Link style={{padding: "10px"}} to="/ready-made-dresses-for-women-summer-2025">Ready Made Dresses for Women Summer 2025</Link>
<Link style={{padding: "10px"}} to="/pakistani-pret-wear-online">Pakistani Pret Wear Online</Link>
<Link style={{padding: "10px"}} to="/best-pakistani-western-clothing-brand">Best Pakistani Western Clothing Brand</Link>
<Link style={{padding: "10px"}} to="/buy-online-ready-made-dresses-in-usa-uk">Buy Online Ready Made Dresses in USA & UK</Link>
<Link style={{padding: "10px"}} to="/ready-to-wear-women-collection-sale-up-to-70-off">Ready to Wear Women Collection Sale Up to 70% Off</Link>
<Link style={{padding: "10px"}} to="/buy-ladies-luxury-pret-wear-collection">Buy Ladies Luxury Pret Wear Collection</Link>
<Link style={{padding: "10px"}} to="/best-women-clothing-brands-in-pakistan">Best Women Clothing Brands in Pakistan</Link>
<Link style={{padding: "10px"}} to="/women-clothing-brand-online-in-pakistan">Women Clothing Brand Online in Pakistan</Link>
<Link style={{padding: "10px"}} to="/latest-dress-designs-womens-clothing-usa-uk">Latest Dress Designs Women's Clothing USA UK</Link>
<Link style={{padding: "10px"}} to="/top-clothing-brand-in-pakistan-premium-women-apparel">Top Clothing Brand in Pakistan | Premium Women Apparel</Link>
<Link style={{padding: "10px"}} to="/luxury-pret-collection-for-women-online">Luxury Pret Collection for Women Online</Link>
<Link style={{padding: "10px"}} to="/buy-ladies-luxury-pret-wear-collection">Buy Ladies Luxury Pret Wear Collection</Link>
<Link style={{padding: "10px"}} to="/ready-to-wear-unstitched-womens-clothing-store">Ready to Wear | Unstitched Women's Clothing Store</Link>
<Link style={{padding: "10px"}} to="/shop-pret-dresses-for-women-online-in-usa">Shop Pret Dresses for Women Online in USA</Link>
<Link style={{padding: "10px"}} to="/shop-the-latest-womens-pret-collection-online">Shop the Latest Women's Pret Collection Online</Link>
<Link style={{padding: "10px"}} to="/luxury-clothing-designer-dresses-for-women">Luxury Clothing & Designer Dresses for Women</Link>
<Link style={{padding: "10px"}} to="/women-dresses-in-uae-explore-latest-pakistani-dresses">Women Dresses in UAE | Explore Latest Pakistani Dresses</Link>
<Link style={{padding: "10px"}} to="/impression-wears-online-clothing-store-for-women">Impression Wears: Online Clothing Store for Women</Link>
<Link style={{padding: "10px"}} to="/valentino-womens-clothing-ready-to-wear-clothes">Valentino Women's Clothing & Ready to Wear Clothes</Link>
<Link style={{padding: "10px"}} to="/ready-to-wear-online-in-pakistan">Ready to Wear Online in Pakistan</Link>










  </p>













    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
    {/* <Link style={{padding: "10px"}} to="/"> 
    </Link> */}
   


            </div>
            </div>
            </div>






              
              {/* End .blog-posts */}
            </main>
            
            {/* End .footer */}
          </div>
          <button id="scroll-top" title="Back to Top">
            <i className="icon-arrow-up" />
          </button>
          {/* Mobile Menu */}
          
          {/* <div className="container newsletter-popup-container mfp-hide" id="newsletter-popup-form">
            <div className="row justify-content-center">
              <div className="col-10">
                <div className="row no-gutters bg-white newsletter-popup-content">
                  <div className="col-xl-3-5col col-lg-7 banner-content-wrap">
                    <div className="banner-content text-center">
                      <img src="assets/images/popup/newsletter/logo.png" className="logo" alt="logo" width={60} height={15} />
                      <h2 className="banner-title">get
                        <span>25</span>
                        <mark>%</mark> off</h2>
                      <p>Subscribe to the Molla eimage_preset newsletter to receive timely updates from your favorite products.</p>
                      <form action="#">
                        <div className="input-group input-group-round">
                          <input type="email" className="form-control form-control-white" placeholder="Your Email Address" aria-label="Email Adress" required />
                          <div className="input-group-append">
                            <button className="btn" type="submit">
                              <span>go</span>
                            </button>
                          </div>
                        </div>
                      </form>
                        <div className="custom-control custom-checkbox">
                        <input type="checkbox" className="custom-control-input" id="register-policy-2" required />
                        <label className="custom-control-label" htmlFor="register-policy-2">Do not show this popup again</label>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-2-5col col-lg-5 ">
                    <img src="assets/images/popup/newsletter/img-1.jpg" className="newsletter-img" alt="newsletter" width={700} height={400} />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        )
    
}

export default Home;